import { useState } from 'react'
import { ReactComponent as CrossIcon } from '../../../../assets/icons/app/cross.icon.svg'
import { BookInterface } from '../../../../core/interface/book.interface'
import GlLoader from '../../../share/GlLoader'
import BookAutoCompleteSelection from './BookAutoCompleteSelection'
import { WM_REPORT_SIZE_MAX_BOOK_SELECTION } from '../../../../core/config/reports/report-details.config'
import { WorkMirrorBookInterface } from '../../../../core/interface/report/work-mirror-book.interface'
import TitleV2 from '../../../analytics-details/work-mirror/TitleV2'
import { AnalyticsPermissionEnum } from '../../../../core/enums/analytics-permission.enum'
import { getBookCoverByClil } from '../../../../core/helpers/clil.helper'
import { CardInputStyle, ItemAuthorStyle } from '../SearchBarComponentsStyle'
import cleanAuthors from '../../../../core/utils/clean-authors.util'

type Props = {
  booksInput: BookInterface[]
  bookDetailsSelected: WorkMirrorBookInterface | null
  isLoadingNewConstellationGetBookReco: boolean
  isLoadingRemove: boolean
  isLoadingAdd: boolean
  permission?: AnalyticsPermissionEnum
  handleBookSelected: (book: WorkMirrorBookInterface | null) => void
  handleRemoveBookInput: (eanId: number) => void
  handleAddBookToAnalytic: (eanId: number) => void
}

const DynamicBooksInput = ({
  booksInput,
  bookDetailsSelected,
  isLoadingNewConstellationGetBookReco,
  isLoadingRemove,
  isLoadingAdd,
  permission,
  handleBookSelected,
  handleRemoveBookInput,
  handleAddBookToAnalytic,
}: Props) => {
  const [indexRemove, setIndexRemove] = useState<number | null>(null)

  const handleBookToSelected = (book: BookInterface) => {
    handleBookSelected(
      bookDetailsSelected?.id_ean === book.id_ean
        ? null
        : {
            popularity: 0,
            position: 0,
            id_ean: book.id_ean,
            book,
          },
    )
  }

  return (
    <div className="flex flex-col gap-1">
      {booksInput.map(
        (bookInput: BookInterface, index: number) =>
          (index === indexRemove && isLoadingRemove && (
            <div
              key={`book-input-details-${bookInput.id_ean}`}
              className="flex flex-row items-center justify-center"
              style={{
                width: '100&',
                height: 40,
              }}
            >
              <GlLoader width={30} height={30} />
            </div>
          )) || (
            <CardInputStyle
              key={`book-input-card-${bookInput.id_ean}`}
              isSelected={bookDetailsSelected?.id_ean === bookInput.id_ean}
              className="relative flex flex-row items-center justify-start gap-2"
              onClick={(event: React.MouseEvent) => {
                event.preventDefault()
                handleBookToSelected(bookInput)
              }}
            >
              <img
                src={bookInput?.imgs || getBookCoverByClil(bookInput.clil1)}
                alt="book cover"
                style={{
                  objectFit: 'contain',
                  minWidth: 40,
                  minHeight: 40,
                  maxWidth: 40,
                  maxHeight: 40,
                  borderRadius: '4px',
                  borderTop: '1px solid transparent',
                  borderBottom: '1px solid transparent',
                }}
              />
              <div className="flex flex-col items-start">
                <TitleV2 title={bookInput?.title?.trim()} />
                <ItemAuthorStyle>
                  {cleanAuthors(bookInput.authors)}
                </ItemAuthorStyle>
              </div>
              {(permission === AnalyticsPermissionEnum.EDIT && (
                <button
                  type="button"
                  className="absolute top-4 right-2 text-black"
                  onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    event.stopPropagation()
                    setIndexRemove(index)
                    handleRemoveBookInput(bookInput?.id_ean)
                  }}
                  disabled={isLoadingAdd || isLoadingRemove}
                >
                  <CrossIcon className="w-3 h-3" />
                </button>
              )) ||
                null}
            </CardInputStyle>
          ),
      )}
      {(isLoadingNewConstellationGetBookReco &&
        booksInput.length < WM_REPORT_SIZE_MAX_BOOK_SELECTION && (
          <div
            className="flex flex-row items-center justify-center"
            style={{
              width: '100&',
              height: 40,
            }}
          >
            <GlLoader width={30} height={30} />
          </div>
        )) ||
        null}
      {(isLoadingAdd &&
        booksInput.length < WM_REPORT_SIZE_MAX_BOOK_SELECTION && (
          <div
            className="flex flex-row items-center justify-center"
            style={{
              width: '100&',
              height: 40,
            }}
          >
            <GlLoader width={30} height={30} />
          </div>
        )) ||
        null}
      {(!isLoadingAdd &&
        !isLoadingNewConstellationGetBookReco &&
        booksInput.length < 3 &&
        permission === AnalyticsPermissionEnum.EDIT && (
          <BookAutoCompleteSelection
            menuOpen
            setMenuOpen={() => null}
            handleAddBookToAnalytic={handleAddBookToAnalytic}
          />
        )) ||
        null}
    </div>
  )
}

export default DynamicBooksInput
